import { useState } from "react";
import useSize from "../../../Utils/useSize/useSize";
import Header from "./Header/Header";
import Create from "./Create/Create";
import Summary from "./Summary/Summary";

import MasterList from "./MasterList/MasterList";

export default function Master() {
  const windowSize = useSize();

  const userType = Number(localStorage.getItem("user_type") || 7);

  const [type, setType] = useState(2);

  const [super_id, setSuperId] = useState(null);

  return (
    <div
      style={{
        height: windowSize[1] - 100,
      }}
    >
      <Header
        type={type}
        updateType={(a) => setType(a)}
        userType={userType}
        supers={(s) => {
          setSuperId(s);
        }}
      />

      {type === 0 ? (
        <Create
          updateType={(a) => setType(a)}
          super_id={super_id}
          userType={userType}
        />
      ) : null}
      {type === 1 ? <Summary super_id={super_id} userType={userType} /> : null}
      {type === 2 ? (
        <MasterList super_id={super_id} userType={userType} />
      ) : null}
    </div>
  );
}
